import {
  createFrontendPlugin,
  createRouteRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import StorageIcon from '@material-ui/icons/Storage';

export const databaseAdminRouteRef = createRouteRef();

const databaseAdminPage = PageBlueprint.make({
  params: {
    path: '/database-admin',
    title: 'Database administration',
    icon: <StorageIcon fontSize="inherit" />,
    routeRef: databaseAdminRouteRef,
    loader: async () => {
      const { DatabaseAdminPage } = await import('./DatabaseAdminPage');
      return <DatabaseAdminPage />;
    },
  },
});

export const databaseAdminPlugin = createFrontendPlugin({
  pluginId: 'database-admin',
  extensions: [databaseAdminPage],
});
